<!-- Le repère visuel du glisser-déposer entoure la zone de saisie et ses boutons : le
     dépôt est capté sur toute la barre de rédaction. -->
<form [formGroup]="form" (submit)="save()" class="flex align-items-center gap-3"
    [class.dragged-over]="dragover">
    <div class="flex-1 border-1 border-200 border-round-3xl relative"
        [ngClass]="{ 'p-1': attachments.length === 0, 'p-2': attachments.length > 0 }">

        <!-- Overlay de suggestions de mention (@) -->
        @if (mentionOverlayVisible) {
        <div class="absolute surface-0 border-1 border-200 border-round-lg shadow-2 overflow-y-auto z-5"
            style="bottom: calc(100% + .5rem); left: 0; right: 0; max-height: 14rem;">
            @for (candidate of filteredMentionCandidates; track (candidate.isInternal ? 'i' : 'e') + candidate.id; let i =
            $index) {
            <div class="flex align-items-center gap-2 p-2 cursor-pointer hover:surface-100"
                [ngClass]="{ 'surface-100': i === activeMentionIndex }"
                (mousedown)="onSelectMentionCandidate(candidate, $event)">
                <app-avatar [user]="candidate.contact.user" [label]="candidate.label"></app-avatar>
                <span class="font-medium">{{ candidate.label }}</span>
                @if (!candidate.isInternal) {
                <span class="text-xs text-500">(externe)</span>
                }
            </div>
            }
        </div>
        }

        <!-- Zone de saisie -->
        <textarea #contentTextarea class="w-full border-none shadow-none" style="resize: none; outline: none;"
            formControlName="content" placeholder="Entrez votre message ici" [rows]="1" [autoResize]="true" pTextarea
            (keyup)="onContentKeyup($event)" (keydown)="onContentKeydown($event)" (click)="onContentClick()"></textarea>

        <!-- Pièces jointes -->
        @if (attachments.length > 0) {
        <div class="flex flex-wrap gap-2 mb-2" [style.pointer-events]="loading ? 'none' : 'auto'">
            @for (attachment of attachments; track attachment.id) {
            <div class="surface-100 border-1 border-200 border-round-3xl p-2 cursor-pointer hover:bg-primary-50 transition-colors transition-duration-200"
                [class.p-disabled]="loading" (click)="onAttachmentClick(attachment)">
                <div class="flex align-items-center gap-2">
                    <i [class]="attachment.mimeTypeIcon + ' text-600'"></i>
                    <span class="text-sm" [title]="attachment.fileName">
                        {{ getTruncatedFileName(attachment.fileName) }}
                    </span>
                    <button type="button" class="p-0 border-none bg-transparent cursor-pointer text-400 hover:text-600"
                        [class.p-disabled]="loading" (click)="onRemoveAttachment(attachment, $event)">
                        <i class="fa-solid fa-times text-xs"></i>
                    </button>
                </div>
            </div>
            }
        </div>
        }
    </div>

    <!-- Boutons d'action -->
    <div class="flex gap-2">
        <!-- Input file caché -->
        <input #fileInput type="file" multiple style="display: none;" (change)="onFileSelected($event)">

        <!-- Bouton visible pour déclencher l'upload -->
        <p-button icon="fa-solid fa-paperclip" type="button" (click)="fileInput.click()" [text]="true" [rounded]="true"
            [disabled]="loading" pTooltip="Joindre un fichier" tooltipPosition="left"></p-button>

        @if (canSendMessage) {
        <p-button icon="pi pi-send" type="submit" pTooltip="Envoyer" tooltipPosition="left" [raised]="true"
            [rounded]="true" [loading]="loading" [disabled]="isSendDisabled"></p-button>
        }
    </div>
</form>